import { forwardRef, ReactNode } from 'react'

import Box, { BoxProps } from 'app/components/base/Box'
import Container from 'app/components/base/Container'

interface ArticlesPanelProps {
  sx?: BoxProps['sx']
  children: ReactNode
}

const ArticlesPanel = forwardRef<HTMLElement, ArticlesPanelProps>(
  ({ children, sx }, ref) => {
    return (
      <Box ref={ref} sx={{ position: 'relative', isolation: 'isolate', ...sx }}>
        <Container
          sx={{
            maxWidth: 940,
            paddingTop: { xs: 2, md: 5 },
            paddingInline: { xs: 0 }
          }}
        >
          {children}
        </Container>
      </Box>
    )
  }
)

export default ArticlesPanel
